import { useMemo } from "react";
import { createDetailsListColumnFactory, detailsListColumnWidths as cw } from "@advosys/component-react";
import { useT } from "./matter-ledger-entries-i18n";
const cf = createDetailsListColumnFactory();
export const useMatterLedgerEntriesColumns = () => {
    const { t } = useT();
    const columns = useMemo(() => [
        cf("date", t.columnDate, cw.date, item => item.date),
        cf("text", t.columnText, cw.longText, item => item.text),
        cf("amount", t.columnAmount, cw.decimal, item => item.amount, { format: "b2", justifyContent: "flex-end", footer: "sum" })
    ], [t]);
    return { columns };
};
